import { PARTNER_ID } from "../../../constants";
import getPartnerIdKey from "../../getPartnerIdKey";

const getPartnerId = (browseCountry, production) => {
  const partnerIdKey = getPartnerIdKey(browseCountry, production);

  return PARTNER_ID[partnerIdKey] || null;
};

export default getPartnerId;
